import React from 'react';
import { Group, Image, Paper, Text } from '@mantine/core';
import moment from 'moment';

import { Declarant, EORIGIN_DATE_FORMAT } from '@e-origin/shared';

import { TranslationFn } from '../translations';

interface UTBHeaderProps {
  declarant: Declarant;
  logo?: string;
  t: TranslationFn;
}

export const UTBHeader = ({ declarant, logo, t }: UTBHeaderProps) => {
  return (
    <Paper mb="xs" p="xs" className="utb-header">
      <Group justify="space-between" align="center">
        <Group>
          {logo && <Image w={60} src={logo} alt="" />}
          <Text>{[declarant.name, declarant.identificationNumber].filter((val) => !!val).join(' - ')}</Text>
        </Group>
        <Text>{t('HEADER.DATE', { date: moment().format(EORIGIN_DATE_FORMAT), time: moment().format('HH:mm') })}</Text>
      </Group>
    </Paper>
  );
};
